import {
  domicilioBuilder,
  DomicilioModel
} from 'app/domicilio/models/DomicilioModel';
import { Role } from './appUsersModels';
import { domicilioInitialValues } from 'shared/components/FormikAddress';

export interface Company {
  company_id: number;
  name: string;
  email: string;
}

export interface UserFormValues {
  fullname?: string;
  first_name?: string;
  last_name?: string;
  email: string;
  phone: string | null;
  company: Company | null;
  role: Role | null;
  alias: string | null;
  address?: DomicilioModel | null;
}

export interface PayLoadAddCorporateUser {
  fullname: string;
  email: string;
  phone: string;
  company_id: number;
}

export interface BackEndDomicilio {
  street: string;
  street_number: number;
  floor?: string;
  apartment?: string;
  locality: string;
  district: string;
  province: string;
  latitude: number;
  longitude: number;
}

export interface PayLoadAddParticularUser {
  first_name: string;
  last_name: string;
  email: string;
  phone_number_one?: string;
  alias?: string;
  address?: BackEndDomicilio;
}

interface CompanyUserById {
  _id: string;
  business_name: string;
  code: number;
  createdAt: string | Date;
  cuit: string;
  fantasy_name: string;
  id: number;
  mail: string;
  updatedAt: string | Date;
}

interface Passenger {
  _id: string;
}

export interface appUserById {
  _id: string;
  company: CompanyUserById;
  createdAt: string | Date;
  is_active: boolean;
  fullname?: string;
  first_name?: string;
  last_name?: string;
  locations: any[];
  notifications: any[];
  number: number;
  passengers: Passenger[] | string[];
  phone: string;
  push_tokens: any[];
  reservations: any[];
  role: Role;
  status: string;
  updatedAt: string | Date;
  username: string;
  email: string;
  __v: number;
  alias: string | null;
  address?: DomicilioModel | null;
  photo: File | string | null;
}

export interface PayLoadEditUser extends PayLoadAddCorporateUser {
  id: string;
}

export interface PayLoadEditParticularUser extends PayLoadAddParticularUser {
  id: string;
}

export const transformUserToFormValues = (
  user: appUserById
): UserFormValues => {
  if (user.role === Role.CORPORATE) {
    return {
      first_name: user.fullname?.split(' ')[0] || '',
      last_name: user.fullname?.split(' ')[1] || '',
      email: user.email,
      phone: user.phone,
      company: {
        company_id: user.company?.id,
        name: user.company?.fantasy_name,
        email: ''
      },
      role: user.role,
      alias: user.alias,
      address: user.address
    };
  } else {
    return {
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      email: user.email,
      phone: user.phone,
      company: {
        company_id: user.company?.id,
        name: user.company?.fantasy_name,
        email: ''
      },
      role: user.role,
      alias: user.alias,
      address: user.address || domicilioInitialValues
    };
  }
};

export const userAppBuilder = {
  fromBackEnd: (appUser): appUserById => {
    return {
      ...appUser,
      address:
        appUser.role === Role.CORPORATE
          ? null
          : appUser.address
          ? domicilioBuilder.fromBackEnd(appUser.address)
          : null
    };
  }
};
